import { useState, useEffect } from 'react';
import HttpService from '../../services/HttpService';


/**
 * Custom hook for fetching a single klant (customer) with proper state management
 */
const useKlant = (id) => {
    const [klant, setKlant] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchKlant = async () => {
            try {
                const url = `${process.env.REACT_APP_API_URL}/Klanten/${id}`;
                const httpService = HttpService;
                httpService.configure();
                const axios = httpService.getAxiosClient();
                setLoading(true);
                setError(false);
                const response = await axios.get(url);
                setKlant(response.data);
            } catch (err) {
                console.error("Error fetching klant:", err);
                setError(true);
                setKlant(null);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchKlant();
        }   
    }, [id]);

    return { klant, loading, error };
};

export default useKlant;